"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _rbush = _interopRequireDefault(require("rbush"));

var _index = require("../index");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function segmentsIntersect(x1, x2, y1, y2) {
  return x2 >= y1 && y2 >= x1;
}

var GranularRectLayout = /*#__PURE__*/function () {
  function GranularRectLayout() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$maxHeight = _ref.maxHeight,
        maxHeight = _ref$maxHeight === void 0 ? 10000 : _ref$maxHeight,
        _ref$spacing = _ref.spacing,
        spacing = _ref$spacing === void 0 ? 2 : _ref$spacing,
        _ref$pitchX = _ref.pitchX,
        pitchX = _ref$pitchX === void 0 ? 1 : _ref$pitchX;

    (0, _classCallCheck2.default)(this, GranularRectLayout);
    (0, _defineProperty2.default)(this, "rectangles", void 0);
    (0, _defineProperty2.default)(this, "maxHeightReached", void 0);
    (0, _defineProperty2.default)(this, "maxHeight", void 0);
    (0, _defineProperty2.default)(this, "rbush", void 0);
    (0, _defineProperty2.default)(this, "spacing", void 0);
    (0, _defineProperty2.default)(this, "pTotalHeight", void 0);
    (0, _defineProperty2.default)(this, "pitchX", void 0);
    // we keep holding onto the concept of pitchX so that when we zoom out
    // layout is redone
    this.pitchX = pitchX;
    this.maxHeightReached = false;
    this.rbush = new _rbush.default();
    this.spacing = spacing;
    this.rectangles = new Map();
    this.maxHeight = Math.ceil(maxHeight);
    this.pTotalHeight = 0;
  }
  /**
   * @returns top position for the rect, or Null if laying
   *  out the rect would exceed maxHeight
   */


  (0, _createClass2.default)(GranularRectLayout, [{
    key: "addRect",
    value: function addRect(id, left, right, height, data) {
      // add to rbush
      var existingRecord = this.rectangles.get(id);

      if (existingRecord) {
        return existingRecord.minY;
      }

      var currHeight = 0;
      var maxHeightReached = false;
      var found = false;

      while ( // 0.01 fudge factor to avoid edge-exact collision detection returning
      // true
      this.rbush.collides({
        minX: left,
        minY: currHeight + 0.01,
        maxX: right,
        maxY: currHeight + height - 0.01
      }) && currHeight <= this.maxHeight) {
        found = true;
        currHeight += 1;

        if (currHeight + height >= this.maxHeight) {
          maxHeightReached = true;
          break;
        }
      }

      if (found) {
        currHeight += this.spacing;
      }

      if (!maxHeightReached) {
        var record = {
          minX: left,
          minY: currHeight,
          maxX: right,
          maxY: currHeight + height,
          id: id,
          data: data
        };
        this.rbush.insert(record);
        this.rectangles.set(id, record);
        this.pTotalHeight = Math.min(this.maxHeight, Math.max(this.pTotalHeight, currHeight + height));
      }

      this.maxHeightReached = this.maxHeightReached || maxHeightReached;
      return maxHeightReached ? null : currHeight;
    }
  }, {
    key: "collides",
    value: function collides() {
      return false;
    }
    /**
     *  Given a range of X coordinates, deletes all data dealing with
     *  the features.
     */

  }, {
    key: "discardRange",
    value: function discardRange() {}
  }, {
    key: "hasSeen",
    value: function hasSeen(id) {
      return this.rectangles.has(id);
    }
  }, {
    key: "getByCoord",
    value: function getByCoord(x, y) {
      var rect = {
        minX: x,
        minY: y,
        maxX: x + 1,
        maxY: y + 1
      };
      return this.rbush.collides(rect) ? this.rbush.search(rect)[0].id : undefined;
    }
  }, {
    key: "getByID",
    value: function getByID(id) {
      var rect = this.rectangles.get(id);

      if (rect) {
        var minX = rect.minX,
            maxX = rect.maxX,
            minY = rect.minY,
            maxY = rect.maxY;
        return [minX, minY, maxX, maxY];
      }

      return undefined;
    }
  }, {
    key: "cleanup",
    value: function cleanup() {}
  }, {
    key: "getTotalHeight",
    value: function getTotalHeight() {
      return this.pTotalHeight;
    }
  }, {
    key: "totalHeight",
    get: function get() {
      return this.getTotalHeight();
    }
  }, {
    key: "serializeRegion",
    value: function serializeRegion(region) {
      var regionRectangles = {};

      var _iterator = _createForOfIteratorHelper(this.rectangles.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
              id = _step$value[0],
              rect = _step$value[1];

          var minX = rect.minX,
              maxX = rect.maxX,
              minY = rect.minY,
              maxY = rect.maxY;
          var start = region.start,
              end = region.end;

          if (segmentsIntersect(start, end, minX, maxX)) {
            regionRectangles[id] = [minX, minY, maxX, maxY];
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return {
        rectangles: regionRectangles,
        totalHeight: this.getTotalHeight(),
        maxHeightReached: this.maxHeightReached
      };
    }
  }, {
    key: "getRectangles",
    value: function getRectangles() {
      return new Map((0, _toConsumableArray2.default)(this.rectangles.entries()).map(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
            id = _ref3[0],
            _ref3$ = _ref3[1],
            minX = _ref3$.minX,
            minY = _ref3$.minY,
            maxX = _ref3$.maxX,
            maxY = _ref3$.maxY;

        return [id, [minX, minY, maxX, maxY]];
      }));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        rectangles: (0, _index.objectFromEntries)(this.getRectangles()),
        totalHeight: this.getTotalHeight(),
        maxHeightReached: this.maxHeightReached
      };
    }
  }]);
  return GranularRectLayout;
}();

exports.default = GranularRectLayout;